import { render, staticRenderFns } from "./angleControl.vue?vue&type=template&id=5c8f5ab8&scoped=true&"
import script from "./angleControl.vue?vue&type=script&lang=js&"
export * from "./angleControl.vue?vue&type=script&lang=js&"
import style0 from "./angleControl.vue?vue&type=style&index=0&id=5c8f5ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f5ab8",
  null
  
)

export default component.exports